<tt-page>
    <tt-list-legacy class="col-xs-12 col-md-6 sp-0" [listItems]="itemsListTrolleys" ltype="custom" [designVar]="'s12t0'" backitem="true" [optionfunc]="goToPrevious"></tt-list-legacy>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListTrolleys" ltype="custom" badge="" design-var="s12t0" backitem="true" optionfunc="vm.goToPrevious(item)"></im-list-directive>
</tt-page>-->
